import { styled, Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

// https://www.figma.com/file/oy0lqfg1RnOZ1Y7129AJmc/KAIZEN-Design-Library?node-id=40%3A11173
const BodySmall = styled(Typography)({
  fontWeight: 400,
  fontSize: '14px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '160%',
  textAlign: 'left',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
});

export const BodySmallStyle = {
  fontWeight: 400,
  fontSize: '14px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '160%',
  textAlign: 'left',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
};

export default BodySmall;
